import { useSuspenseQuery } from '@tanstack/react-query';
import { ApiCallsV2 } from '../api/apiV2';
import { INIT_DATA_V2 } from '../constants/queryKeys';

export const useInitialData = () => {
    return useSuspenseQuery({
        queryKey: [INIT_DATA_V2],
        queryFn: () => ApiCallsV2.getInitialData({}).then(res => res.data),
        staleTime: Infinity,
        cacheTime: Infinity,
    });
};
